import React from 'react'
import { Link } from 'react-router-dom'
import { reverseUrl } from '../../../../../navigation/reverseUrl'
import { theme } from '../../../../../theme/theme'
import { AvatarInner } from '../../../../common/Avatar'
import { PostContactCard } from '../../../../../generated/api/post-row'

interface ContactItemProps {
  contact: PostContactCard
}

export const ContactItem = ({
  contact,
}: ContactItemProps): JSX.Element | null => {
  return (
    <Link
      className="flex w-full cursor-pointer flex-row items-center rounded-lg p-4 hover:bg-neutral-96"
      to={reverseUrl(
        contact.kind === 'society' ? 'society:contacts' : 'management:contacts',
        {
          id: contact.societyId,
        }
      )}
      style={{ textDecoration: 'none' }}
    >
      <div className="flex items-center gap-4">
        <AvatarInner url={contact.avatarUrl} size={120} />
        <div>
          <p
            className="mb-1 text-black line-clamp-1"
            style={theme.textVariants.lead}
          >
            {contact.name}
          </p>
          <p
            className="m-0 text-neutral-50 line-clamp-1"
            style={theme.textVariants.base}
          >
            {contact.title}
          </p>
        </div>
      </div>
    </Link>
  )
}
